<p-tree
    [value]="value"
    selectionMode="single"
    [(selection)]="selection"
    styleClass="sera-tree"
    (onNodeSelect)="emitNodeSelection($event)">
    <ng-template
        let-node
        #default>
        <div class="sera-tree-span-container">
            <span
                class="sera-tree-span"
                pTooltip="{{ node.label }}"
                tooltipPosition="right"
                [showDelay]="200"
                [hideDelay]="100"
                >{{ node.label }}</span
            >
        </div>
    </ng-template>
</p-tree>
